import { AUTH_LOGOUT } from "actions/auth";
import {
  SET_CART,
  SET_DTF_CART_LOADING,
  SET_DTF_CART_ERROR,
  CLEAR_DTF_CART,
} from "actions/dtfCart";

const initialState = {
  items: [],
  count: 0,
  loading: false,
  error: null,
};

const dtfCart = (state = initialState, action = null) => {
  switch (action.type) {
    case SET_CART:
      return {
        ...state,
        items: action.items,
        count: action.count,
        error: null,
      };

    case SET_DTF_CART_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case SET_DTF_CART_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case CLEAR_DTF_CART:
    case AUTH_LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default dtfCart;
